import styled from '@emotion/styled'
import { StyledLiveBubble } from '../../typography/EditorialLabel/EditorialLabel.styled'
import { breakpoint, calcRem, colors, themedValue } from '../../__styling'

export const StyledContainer = styled('div')({
    marginBottom: '16px',
    position: 'relative',
})

export const StyledJumpButtonContainer = styled('div')({
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: -40,
    left: 0,
    right: 0,
    pointerEvents: 'none',
})

export const StyledButtonContainer = styled('div')(({ theme }) => ({
    height: 'auto',
    display: 'flex',
    justifyContent: themedValue(theme, {
        sevennews: 'center',
        fallback: 'flex-start',
    }),
    flexWrap: 'wrap',
}))

interface StyledReportingLiveContainerProps {
    isActive: boolean
}

export const StyledReportingLiveContainer = styled(
    'div',
)<StyledReportingLiveContainerProps>(({ theme, isActive }) => ({
    background: theme.colors.brand,
    height: isActive
        ? themedValue(theme, {
              fallback: calcRem(48),
              sevennews: calcRem(30),
          })
        : calcRem(4),
    padding: isActive
        ? themedValue(theme, {
              fallback: calcRem(16),
              sevennews: calcRem(8),
          })
        : 0,
    overflow: themedValue(theme, {
        fallback: 'auto',
        sevennews: 'hidden',
    }),
    marginLeft: theme.margins.md * -1,
    marginRight: theme.margins.md * -1,
    marginTop: themedValue(theme, {
        sevennews: calcRem(15),
        fallback: 'unset',
    }),
    display: isActive
        ? 'flex'
        : themedValue(theme, {
              fallback: 'flex',
              sevennews: 'none',
          }),
    alignItems: 'center',

    [breakpoint('md')]: {
        marginLeft: themedValue(theme, {
            fallback: theme.margins.md * -1,
            sevennews: (theme.margins.md - 8) * -1,
        }),
        marginRight: themedValue(theme, {
            fallback: theme.margins.md * -1,
            sevennews: (theme.margins.md - 8) * -1,
        }),
    },
}))

export const StyledReportingLiveText = styled('span')(({ theme }) => ({
    fontFamily: themedValue(theme, {
        thewest: theme.fonts.sansSerif,
        perthnow: theme.fonts.sansSerif,
        sevennews: theme.fonts.sansSerif,
        fallback: undefined,
    }),
    fontSize: calcRem(15),
    fontWeight: themedValue(theme, {
        sevennews: 400,
        fallback: 700,
    }),
    color: theme.colors.palette.white,
    lineHeight: calcRem(16),

    '& > span': {
        fontWeight: themedValue(theme, {
            sevennews: 600,
            fallback: 700,
        }),
    },
}))

export const StyledReportingLiveDivider = styled('hr')(({ theme }) => ({
    overflow: 'auto',
    border: 'none',
    margin: 0,
    height: 0,
    background: themedValue(theme, {
        thewest: colors.thewest.greyQuokka,
        perthnow: colors.thewest.greyQuokka,
        sevennews: 'inherit',
        thenightly: undefined,
    }),

    [breakpoint('md')]: {
        height: calcRem(1),
        marginLeft: theme.margins.md * -1,
        marginRight: theme.margins.md * -1,
        marginTop: calcRem(8),
    },
}))

export const StyledReportingLiveBubble = styled(StyledLiveBubble)(
    ({ theme }) => ({
        backgroundColor: theme.colors.palette.white,
        marginLeft: themedValue(theme, {
            sevennews: calcRem(22),
            fallback: '0rem',
        }),
        marginRight: themedValue(theme, {
            sevennews: '0.4rem',
            fallback: '0.5rem',
        }),
        width: '0.6em',
        height: '0.6em',
    }),
)
